import { useEffect } from 'react';

import { useLazyQuery } from '@apollo/client';
import { AddMerchantApplication, Partner, PartnerOfPartner, User } from '@prisma/client';

import BorderedCard from 'src/components/BorderedCard/BorderedCard';
import { Flex } from 'src/components/Flex';
import LabeledValues from 'src/components/LabelledValues';
import { GET_PARTNER } from 'src/graphql/queries/partners.query';
import { GET_PARTNER_OF_PARTNER } from 'src/graphql/queries/subpartners.query';

interface AuthorServiceDetailsProps {
    application: AddMerchantApplication & {
        author: User;
        partner: Partner & {
            business?: {
                legalName: string;
            };
        };
        partnerOfPartner?: PartnerOfPartner & {
            business?: {
                legalName: string;
            };
        };
    };
}
const AuthorServiceDetails = ({ application }: AuthorServiceDetailsProps) => {
    const partnersName =
        application?.partner?.business?.legalName ||
        application?.partnerOfPartner?.business?.legalName ||
        '';

    const [getPartner, { data: partnerData }] = useLazyQuery(GET_PARTNER);

    const [getPartnerOfPartner, { data: partnerOfPartnerData }] =
        useLazyQuery(GET_PARTNER_OF_PARTNER);

    useEffect(() => {
        const partnerId = application?.partnerId;
        const partnerOfPartnerId = application?.partnerOfPartnerId;

        if (partnerId) {
            getPartner({ variables: { id: partnerId } });
        }
        if (partnerOfPartnerId) {
            getPartnerOfPartner({ variables: { id: partnerOfPartnerId } });
        }
    }, [getPartner, getPartnerOfPartner, application?.partnerId, application?.partnerOfPartnerId]);

    const partnerName =
        partnerOfPartnerData?.partnerOfPartner?.business?.legalName ||
        partnerData?.partner?.business?.legalName ||
        partnersName;

    const serviceType = application?.serviceRequirements?.service?.serviceType;
    const sellersDetails = {
        name: `${application?.author?.firstName ?? ''} ${application?.author?.lastName ?? ''}`,
        email: application?.author?.email,
    };
    const isServiceApplication = application?.isServiceApplication;
    const id = application?.id;
    return (
        <Flex gap={4}>
            <BorderedCard flexDirection="column" width={'100%'}>
                <LabeledValues label="Partner Name" value={partnerName ?? ''} />
                <LabeledValues
                    label="Seller's Details"
                    value={`${sellersDetails?.name ?? ''} / ${sellersDetails?.email ?? ''}`}
                />
            </BorderedCard>
            <BorderedCard
                flexDirection="column"
                sx={{
                    justifyContent: 'center',
                }}
                width={'100%'}
            >
                <LabeledValues
                    label={`${
                        isServiceApplication ? 'Add Service Application ID' : 'Application ID'
                    }`}
                    value={id ?? ''}
                />
                <LabeledValues label="Service Type" value={serviceType ?? ''} />
            </BorderedCard>
        </Flex>
    );
};
export default AuthorServiceDetails;
